export default "__VITE_ASSET__BSKgwxHb__"